import * as dotProp from 'dot-prop-immutable';
import { createReducer } from '@topconagriculture/frontend-utils';
import { hideLoader, showLoader } from './loader.actions';
export const initialState = {
    loaders: {},
};
const loaderReducer = createReducer(initialState, {
    [showLoader.type]: (state, action) => {
        return dotProp.set(state, `loaders.${action.payload}`, true);
    },
    [hideLoader.type]: (state, action) => {
        return dotProp.set(state, `loaders.${action.payload}`, false);
    },
});
export default { loader: loaderReducer };
//# sourceMappingURL=loader.reducer.js.map